export const ELEMENT_Z_INDEX = 4;
export const OVERLAY_COMPONENT_Z_INDEX = 5;
export const TRANSFORMING_ELEMENT_Z_INDEX = 6;
